<template>
  <div class="white-wrapper">
    <div>
      <div class="row">
        <div class="col-12 mb-4 pt-2">
          <div class="row">
            <div class="col-3">
              <b-dropdown
                :text="dropDowns.cinemaDropdown.cinemaSelected.cine_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in dropDowns.cinemaDropdown.cinemas"
                  href="#"
                  :key="cinemaIndex"
                  name="cinemaDropdown"
                  id="cinemaDropdown"
                  v-on:click="dropDowns.cinemaDropdown.cinemaSelected = cinema;getScreens(cinema);"
                >{{cinema.cine_name}}</b-dropdown-item>
              </b-dropdown>
              <p v-if="submitted" class="error_message">{{ errormsg }}</p>
            </div>

            <div class="col-3">
              <b-dropdown
                :text="dropDowns.screenDropdown.screenSelected.screen_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(screen, screenIndex) in dropDowns.screenDropdown.screens"
                  href="#"
                  :key="screenIndex"
                  name="screenDropdown"
                  id="screenDropdown"
                  v-on:click="dropDowns.screenDropdown.screenSelected = screen;getScreenSeatType(screen);screenSeatTypes=screen.screen_seat_type"
                >{{screen.screen_name}}</b-dropdown-item>
              </b-dropdown>
              <p v-if="submitted" class="error_message">{{ errormsg2 }}</p>
              <!-- <p class="error_message">{{ $t('blankfieldmsg') }}</p> -->
            </div>
            <div class="col-3">
              <div class="input-material">
                <input
                  @change="onChangeRowsColumns()"
                  v-model="rows"
                  type="text"
                  placeholder="."
                  v-validate="'required|numeric'"
                  name="Enter_Rows"
                  id="Enter_Rows"
                />
                <label>Rows</label>
              </div>
              <p v-if="submitted && errors.has('Enter_Rows')" class="error_message">
                <!-- {{ item.fieldname }} -->
                {{ errors.first("Enter_Rows")}}
              </p>
            </div>
            <div class="col-3">
              <div class="input-material">
                <input
                  v-on:change="onChangeRowsColumns()"
                  v-model="columns"
                  type="text"
                  name="Enter_Columns"
                  id="Enter_Columns"
                  v-validate="'required|numeric'"
                  placeholder="."
                />
                <label>columns</label>
              </div>
              <p v-if="submitted && errors.has('Enter_Columns')" class="error_message">
                <!-- {{ item.fieldname }} -->
                {{ errors.first("Enter_Columns")}}
              </p>
            </div>
          </div>
        </div>

        <div class="col-12">
          <header class="cinema-header">
            <div class="row justify-content-between">
              <div class>
                <div class="d-flex justify-content-end align-items-center">
                  <div
                    v-for="(seatType, seatTypeIndex) in seatTypes"
                    :key="seatTypeIndex"
                    class="mx-1 mx-xl-3"
                    v-on:click="selectSeatType(seatType)"
                  >
                    <div class="cinema-seat my-0 mx-auto bg-blue" :class="seatType.imageClass"></div>
                    <small>{{seatType.seatName}}</small>
                  </div>

                  <div class="divider mx-1 mx-xl-3"></div>

                  <div
                    class="mx-1"
                    v-for="(screenSeatType, screenSeatTypeIndex) in screenSeatTypes"
                    :key="'index' + screenSeatTypeIndex"
                  >
                    <b-button
                      variant="default"
                      class="btn-outline-blue"
                      v-on:click="selectScreenSeatType(screenSeatType)"
                      :style="{ borderColor: screenSeatType.sst_seat_color_code, backgroundColor: screenSeatType.sst_seat_color_code,color: 'white'}"
                    >{{screenSeatType.sst_seat_type}}</b-button>
                  </div>
                  <div class="mx-1">
                    <button
                      v-on:click="showName = !showName"
                      :class="showName ? 'btn-blue' : 'btn-outline-blue'"
                    >Show Grid</button>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>

        <div class="col-12">
          <h5 class="text-center pt-3">All Eyes This Way</h5>
          <div
            class="cinema-seatlayout"
            onmousedown="vmVue.$emit('mouseKeyDown', 'test')"
            onmouseup="vmVue.$emit('mouseKeyUp', 'test')"
          >
            <table class="generateSeatLayout">
              <!-- REGULAR SEATS -->

              <tr v-for="(row, rowIndex) in seats" :key="rowIndex">
                <!-- <tr v-for="(row, rowIndex) in parseInt(rows)" :key="rowIndex"> -->
                <td>
                  <div class="cinema-seatNumber">{{row.rowName}}</div>
                  <input
                    v-if="showName"
                    type="text"
                    class="changeSeatName"
                    v-model="seats[rowIndex].rowName"
                    @change="changeRowName()"
                  />
                </td>
                <td
                  v-for="(column , columnIndex) in row.singleRow"
                  :key="'singleSeat' + columnIndex+1"
                  colspan="1"
                >
                  <!-- :colspan="seats[row][singleSeat].seatType == 'love-seat'? 2 : 1" -->
                  <div class="cinema-seatNumber">{{columnIndex+1}}</div>
                  <div
                    v-if="!showName && seats[rowIndex] && seats[rowIndex].singleRow[columnIndex]"
                    @mousedown="mouseDownOnSeat(columnIndex, rowIndex)"
                    @mouseover="mouseOverSeat(columnIndex, rowIndex)"
                    class="cinema-seat"
                    :class="seats[rowIndex].singleRow[columnIndex].seatType.imageClass"
                    :style="{ borderColor: seats[rowIndex].singleRow[columnIndex].screenSeatType.sst_seat_color_code, backgroundColor: seats[rowIndex].singleRow[columnIndex].screenSeatType.sst_seat_color_code}"
                  ></div>
                  <!-- :style="{ borderColor: seats[rowIndex][columnIndex].screenSeatType.sst_seat_color_code, backgroundColor: seats[rowIndex][columnIndex].screenSeatType.sst_seat_color_code}" -->

                  <input
                    v-if="showName"
                    type="text"
                    class="changeSeatName"
                    v-model="seats[rowIndex].singleRow[columnIndex].seatName"
                  />
                  <!-- {{seats[rowIndex][columnIndex]}} -->
                  <!-- :class="seats[row][column].seatTypeImageClass" -->

                  <!-- v-bind:class="{ 'vip-seat': singleSeat.seatTypeImageClass, 'normal-seat': singleSeat.seatTypeImageClass }" -->
                </td>

                <td>
                  <div class="cinema-seatName">{{row.rowName}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-12 py-2 text-center">
          <!-- to="add-seat-layout" -->
          <b-button variant="default" class="btn-blue" @click.prevent.stop="submitSeatLayout()">Save</b-button>
          <b-button variant="default" to="cinema-concession-levels" class="btn-blue">Skip</b-button>
          <b-button variant="default" to="add-seat-layout" class="btn-black">Reset</b-button>
          <b-button variant="default" to="add-screens" class="btn-black">Back</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScreenService from "@/services/MasterService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      submitted: false,
      // screenID: 0,
      dropDowns: {
        cinemaDropdown: {
          cinemas: [],
          cinemaSelected: {
            cine_name: "Select Cinema"
          }
        },
        screenDropdown: {
          screens: [],
          screenSelected: {
            screen_name: "Select Screen"
          }
        }
      },
      screenSeatTypes: [],
      showName: false,
      seatTypeSelected: {
        seatName: "regularSeat",
        size: 1,
        imageClass: "regular-seat"
      },
      screenSeatTypeSelected: {},
      seatTypeSelectionMode: "seatType",
      mouseDownStatus: false,
      initialSeatValueSelected: {
        row: 0,
        column: 0
      },
      finalSeatValueSelected: {
        row: 0,
        column: 0
      },
      seatTypes: [
        {
          seatName: "vipSeat",
          size: 1,
          value: 5,
          imageClass: "vip-seat"
        },
        {
          seatName: "regularSeat",
          size: 1,
          value: 1,
          imageClass: "regular-seat"
        },
        {
          seatName: "noSeat",
          size: 1,
          value: 2,
          imageClass: "no-seat"
        },
        {
          seatName: "wheelchair",
          size: 1,
          value: 3,
          imageClass: "wheelchair"
        },
        {
          seatName: "sofa",
          size: 1,
          value: 10,
          imageClass: "regular-seat"
        },
        {
          seatName: "recliner",
          size: 1,
          value: 11,
          imageClass: "recliner"
        },
        {
          seatName: "LoveSeat",
          size: 6,
          imageClass: "love-seat"
        }
      ],
      rows: 1,
      columns: 1,
      seats: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas"
      },
      errormsg: "",
      errormsg2: ""
      // "vipSeat", "regularSeat", "NoSeat", "WheelChair"],
    };
  },
  beforeMount() {
    // this.onChangeRowsColumns();
    this.getCinemas();
    // this.getScreens();
  },
  mounted() {
    vmVue.$on("mouseKeyDown", this.mouseDown);
    vmVue.$on("mouseKeyUp", this.mouseUp);
    // vmVue.$on("mouseKeyDown", this.mouseDown);
    // vmVue.$on("mouseKeyUp", this.mouseUp);
  },
  methods: {
    changeRowName: function() {
      console.log("test :");
      let newSeats = this.seats;
      this.seats = [];

      for (let i = 0; i < newSeats.length; i++) {
        let seatRow = [];
        let z = 0;
        for (let j = 0; j < newSeats[0].singleRow.length; j++) {
          console.log("singleSeat :", singleSeat);
          let singleSeat = newSeats[i].singleRow[j];

          if (singleSeat.seatType.value == 7) {
            singleSeat.seatName = "";
          } else {
            singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
            z++;
          }
          console.log("singleSeat :", singleSeat);

          seatRow.push(singleSeat);
        }
        this.seats.push({
          rowName: newSeats[i].rowName,
          singleRow: seatRow
        });
      }
    },
    // submitSeatLayout: function() {
    //   console.log("submitSeatLayout");
    //   let allSeats = [];
    //   for (let i = 0; i < this.seats.length; i++) {
    //     for (let j = 0; j < this.seats[0].length; j++) {
    //       allSeats.push({
    //         sl_row_num: i + 1,
    //         sl_seat_name: that.seats[i][j].seatName,
    //         sl_col_num: j + 1,
    //         screen_seat_type_id: that.seats[i][j]["screenSeatType"].sst_id, // seats[i][j].seatType.seatTypeID
    //         sl_seat_status: "0",
    //         seat_reserve_type_id: that.seats[i][j]["seatType"].value
    //         // seatType: this.seatTypeSelected,
    //         // seatTypeImageClass: this.seatTypeSelected.imageClass,
    //         // seatName: newSeats[i][j].seatName,
    //         // anyOtherData: "test"
    //       });
    //     }
    //   }

    //   let payload = {
    //     screen_layout: allSeats,
    //     // screen_layout: [
    //     //   {
    //     //     sl_row_num: 1,
    //     //     sl_seat_name: "",
    //     //     sl_col_num: 1,
    //     //     screen_seat_type_id: 643,
    //     //     sl_seat_status: "0",
    //     //     seat_reserve_type_id: 1
    //     //   },
    //     //   {
    //     //     sl_row_num: 1,
    //     //     sl_seat_name: "",
    //     //     sl_col_num: 2,
    //     //     screen_seat_type_id: 643,
    //     //     sl_seat_status: "0",
    //     //     seat_reserve_type_id: 1
    //     //   }
    //     // ],
    //     screen_id: this.dropDowns.screenDropdown.screenSelected.screen_id || 1,
    //     sl_row_num_tot: this.rows,
    //     sl_col_num_tot: this.columns
    //   };

    //   SetupService.addScreenLayout(payload)
    //     .then(response => {
    //       const { data } = response;
    //       console.log(response);
    //       if (!data.error) {
    //         this.$router.psush({
    //           path: "price-master"
    //         });
    //       } else {
    //       }
    //     })
    //     .catch(error => {
    //       this.showMessageSnackbar("Error in getReportListData ", error);
    //     });
    // },
    submitSeatLayout: function() {
      this.submitted = true;
      if (
        this.dropDowns.cinemaDropdown.cinemaSelected.cine_name ==
        "Select Cinema"
      ) {
        if (
          this.dropDowns.screenDropdown.screenSelected.screen_name ==
          "Select Screen"
        ) {
          this.errormsg = "Please Select Cinema.";
          this.errormsg2 = "Please Select Screen.";
        } else {
          this.errormsg = "Please Select Cinema.";
        }
      } else if (
        this.dropDowns.screenDropdown.screenSelected.screen_name ==
        "Select Screen"
      ) {
        this.errormsg2 = "Please Select Screen.";
      } else {
        this.$validator.validate().then(valid => {
          console.log("valid :", valid);
          if (valid) {
            console.log("test");
            let allSeats = [];
            let that = {
              seats: this.seats
            };
            for (let i = 0; i < this.seats.length; i++) {
              for (let j = 0; j < this.seats[0].singleRow.length; j++) {
                console.log("that.seats :", that.seats);
                allSeats.push({
                  sl_row_num: i + 1,
                  sl_seat_name: that.seats[i].singleRow[j].seatName,
                  sl_col_num: j + 1,
                  screen_seat_type_id:
                    that.seats[i].singleRow[j]["screenSeatType"].sst_id, // seats[i][j].seatType.seatTypeID
                  sl_seat_status: "0",
                  seat_reserve_type_id:
                    that.seats[i].singleRow[j]["seatType"].value
                  // seatType: this.seatTypeSelected,
                  // seatTypeImageClass: this.seatTypeSelected.imageClass,
                  // seatName: newSeats[i][j].seatName,
                  // anyOtherData: "test"
                });
              }
            }

            let payload = {
              screen_layout: allSeats,
              // screen_layout: [
              //   {
              //     sl_row_num: 1,
              //     sl_seat_name: "",
              //     sl_col_num: 1,
              //     screen_seat_type_id: 643,
              //     sl_seat_status: "0",
              //     seat_reserve_type_id: 1
              //   },
              //   {
              //     sl_row_num: 1,
              //     sl_seat_name: "",
              //     sl_col_num: 2,
              //     screen_seat_type_id: 643,
              //     sl_seat_status: "0",
              //     seat_reserve_type_id: 1
              //   }
              // ],
              screen_id: this.dropDowns.screenDropdown.screenSelected.screen_id,
              sl_row_num_tot: this.rows,
              sl_col_num_tot: this.columns
            };
            console.log("JSON.stringyfy() :", JSON.stringify(payload));
            ScreenService.addScreenLayout(payload)
              .then(response => {
                const { data } = response;
                console.log(response);
                if (!data.error) {
                  this.$router.push({
                    path: "cinema-concession-levels"
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(error => {
                this.$toasted.show(error);

                // this.showMessageSnackbar("Error in getReportListData ", error);
              });
          }
        });
      }
    },
    getCinemas: function() {
      this.dropDowns.cinemaDropdown.cinemas = [];
      // let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDowns.cinemaDropdown.cinemas = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getScreenSeatType: function(screen) {
      let payload = {
        tableName: "screen_seat_type",
        sst_is_active: "Y", // // Get cinema_id when user will login // if cinema_id is null he can't access this page.
        screen_id: screen.screen_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.posOperations = data.Records;
            this.screenSeatTypes = data.Records;
            this.onChangeRowsColumns();

            //getseatreservetype

            // this.onChangeRowsColumns();
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });

      // ScreenService.getScreenSeatType({ screenID: this.screenID })
      //   .then(response => {
      //     const { data } = response;
      //     console.log(response);
      //     if (!data.error) {
      //       this.dropDowns.cinemaDropdown.cinemas = data.data;
      //     } else {
      //     }
      //   })
      //   .catch(error => {
      //     this.showMessageSnackbar("Error in getReportListData ", error);
      //   });
    },

    getScreens: function(cinema) {
      let body = {
        activekey: "screen_is_active",
        conditionColName: "cinema_id",
        conditionId: cinema.cine_id
      };
      CinemasService.GetActiveScreenByCinema(body)
        .then(response => {
          const { data } = response;
          console.log("asasasas", data);
          if (!data.error) {
            this.dropDowns.screenDropdown.screens = data.Records;
            this.rows = data.Records[0].screen_no_of_rows;
            this.columns = data.Records[0].screen_no_of_cols;
          } else {
          }
        })
        .catch(error => {
          // this.showMessageSnackbar("Error in getReportListData ", error);
        });
    },
    // onChangeRowsColumns: function() {
    //   console.log("test");
    //   this.seats = [];
    //   var seatRow = [];
    //   for (let i = 0; i < this.rows; i++) {
    //     seatRow = [];
    //     for (let j = 0; j < this.columns; j++) {
    //       seatRow.push({
    //         seatType: "normal",
    //         seatTypeImageClass: "normal-seat",
    //         seatName: String.fromCharCode(i + 65) + parseInt(j + 1),
    //         anyOtherData: "test"
    //       });
    //     }
    //     this.seats.push(seatRow);
    //     // console.log(this.seats, seatRow);
    //   }
    //   // console.log(this.seats, seatRow);

    //   // for (let i = 0; i++; i < this.rows) {
    //   //   for (let j = 0; j++; j < this.columns) {
    //   //     seats[i][j] = {
    //   //       seatType: "normal",
    //   //       anyOtherData: "test"
    //   //     };
    //   //   }
    //   // }
    // },
    onChangeRowsColumns: function() {
      console.log("test");
      this.seats = [];
      var seatRow = [];
      for (let i = 0; i < this.rows; i++) {
        seatRow = {
          singleRow: [],
          rowName: String.fromCharCode(i + 65)
        };
        for (let j = 0; j < this.columns; j++) {
          seatRow.singleRow.push({
            screenSeatType: this.screenSeatTypes[0],
            seatType: {
              seatName: "regularSeat",
              size: 1,
              value: 1,
              imageClass: "regular-seat"
            },
            seatTypeImageClass: "normal-seat",
            seatName: seatRow.rowName + parseInt(j + 1),
            anyOtherData: "test"
          });
        }
        this.seats.push(seatRow);
        console.log("this.seatdwvwtrfyewiuhe872t872y92uw92w9s,", this.seats);
      }
      // console.log(this.seats, seatRow);

      // for (let i = 0; i++; i < this.rows) {
      //   for (let j = 0; j++; j < this.columns) {
      //     seats[i][j] = {
      //       seatType: "normal",
      //       anyOtherData: "test"
      //     };
      //   }
      // }
    },
    selectScreenSeatType: function(seatScreenType) {
      console.log(seatScreenType);
      this.screenSeatTypeSelected = seatScreenType;
      this.seatTypeSelectionMode = "screenSeatType";
    },
    selectSeatType: function(seatType) {
      console.log(seatType);
      this.seatTypeSelected = seatType;
      this.seatTypeSelectionMode = "seatType";
    },
    mouseDown: function() {
      console.log("testmouseDown", this.mouseDownStatus);
      this.mouseDownStatus = true;
      console.log("testmouseDown2", this.mouseDownStatus);

      // this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    mouseUp: function() {
      console.log("testmouseUp", this.mouseDownStatus);
      this.mouseDownStatus = false;
      console.log("testmouseUp2", this.mouseDownStatus);
    },
    mouseDownOnSeat: function(seatColumnSelected, seatRowSelected) {
      console.log("mouseclick");
      this.initialSeatValueSelected.column = seatColumnSelected;
      this.initialSeatValueSelected.row = seatRowSelected;
      this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    // mouseOverSeat: function(seatColumnSelected, seatRowSelected, clickStatus) {
    //   console.log("this.mouseDownStatus", this.mouseDownStatus, clickStatus);

    //   if (!clickStatus) {
    //     this.finalSeatValueSelected.column = seatColumnSelected;
    //     this.finalSeatValueSelected.row = seatRowSelected;
    //   }
    //   if (this.mouseDownStatus || clickStatus == true) {
    //     console.log("seatColumn :", seatColumnSelected);
    //     console.log("seatRow :", seatRowSelected);
    //     let newSeats = this.seats;
    //     this.seats = [];

    //     for (let i = 0; i < newSeats.length; i++) {
    //       let seatRow = [];
    //       for (let j = 0; j < newSeats[0].length; j++) {
    //         // console.log("row=", i, "column", j, seatRow, seatColumn);
    //         //Do math to select between final and initial row && final and initial column
    //         if (seatRowSelected == i && seatColumnSelected == j) {
    //           seatRow.push({
    //             seatType: this.seatTypeSelected,
    //             seatTypeImageClass: this.seatTypeSelected.imageClass,
    //             seatName: newSeats[i][j].seatName,
    //             anyOtherData: "test",
    //             screenSeatType: this.seatTypeSelected
    //           });
    //         } else {
    //           seatRow.push(newSeats[i][j]);
    //         }
    //         // console.log(this.seats, seatRow);
    //       }
    //       this.seats.push(seatRow);
    //     }
    //     // this.$set(this.items, indexOfItem, newValue)
    //   }
    // }
    mouseOverSeat: function(seatColumnSelected, seatRowSelected, clickStatus) {
      console.log("this.mouseDownStatus", this.mouseDownStatus, clickStatus);

      if (!clickStatus) {
        this.finalSeatValueSelected.column = seatColumnSelected;
        this.finalSeatValueSelected.row = seatRowSelected;
      }
      if (this.mouseDownStatus || clickStatus == true) {
        console.log("seatColumn :", seatColumnSelected);
        console.log("seatRow :", seatRowSelected);
        let newSeats = this.seats;
        this.seats = [];

        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            console.log("row=", i, "column", j, seatRow);
            //Do math to select between final and initial row && final and initial column
            if (seatRowSelected == i && seatColumnSelected == j) {
              if (this.seatTypeSelectionMode == "screenSeatType") {
                // console.log(
                //   "object :",
                //   newSeats[i][j],
                //   this.screenSeatTypeSelected
                // );
                let singleSeat = {
                  seatType: newSeats[i].singleRow[j].seatType, //normal, wheelchair, empty
                  screenSeatType: this.screenSeatTypeSelected,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test1"
                };
                if (newSeats[i].singleRow[j].seatType.value == 2) {
                  singleSeat.seatName = "";
                } else {
                  singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                  z++;
                }
                seatRow.push(singleSeat);

                //create
              } else {
                // console.log("object1 :", newSeats[i][j]);
                let singleSeat = {
                  seatType: this.seatTypeSelected, //normal, wheelchair, empty
                  screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test2"
                };
                if (this.seatTypeSelected.value == 2) {
                  singleSeat.seatName = "";
                } else {
                  singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                  z++;
                }
                seatRow.push(singleSeat);
              }
            } else {
              console.log("singleSeat :", singleSeat);
              let singleSeat = newSeats[i].singleRow[j];
              if (this.seatTypeSelectionMode == "screenSeatType") {
                if (newSeats[i].singleRow[j].seatType.value == 2) {
                  singleSeat.seatName = "";
                } else {
                  singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                  z++;
                }
              } else {
                if (singleSeat.seatType.value == 2) {
                  singleSeat.seatName = "";
                } else {
                  singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                  z++;
                }
              }
              console.log("singleSeat :", singleSeat);

              seatRow.push(singleSeat);
            }
            // console.log(this.seats, seatRow);
          }
          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow
          });
        }
        // this.$set(this.items, indexOfItem, newValue)
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Installation/addSeatLayout.vue